module.exports = __webpack_public_path__ + "static/media/LU.85c25884.png";